import BaseLayoutView from 'app/src/views/base/BaseLayoutView';

import paymentViewTemplate from './templates/modal-view.hbs';

let _Events = {
  MODAL_CLOSE_REQUESTED: 'modal:close:requested',
  MODAL_BACK_BUTTON_CLICKED: 'modal:back:button:clicked',
  MODAL_CLOSE_CLICKED: 'modal:close:clicked',
};

// configure
let View = BaseLayoutView.extend({
  template: paymentViewTemplate,
  regions: {
    content: '.modal-content',
    footer: '.modal-footer',
  },

  className: 'modal-overlay animate-in',

  ui: {
    container: '.modal-container',
    backButton: '.modal-back-button',
    footer: '.modal-footer',
    title: 'h1',
    close: 'i.modal-close',
  },

  triggers: {
    'click @ui.backButton': _Events.MODAL_BACK_BUTTON_CLICKED,
    'click @ui.close': _Events.MODAL_CLOSE_CLICKED,
  },
});

// define
export default class ModalView extends View {
  /**
   * Called to dismiss the modal.  When invoked, it will trigger the dismiss animation
   * at the end of which it will trigger the modal closed event which the AppViewManager
   * will be listening to to properly cleanup up the modal region.
   */
  dismiss() {
    this.$el.one('animationend webkitAnimationEnd', () => {
      this.trigger(_Events.MODAL_CLOSE_REQUESTED);
    });

    this.ui.container.removeClass('animate-in').addClass('animate-out');
    this.$el.removeClass('animate-in').addClass('animate-out');
  }

  /**
   * Show the back button in the header area.
   *
   * @param {boolean} show    When true, will show the back button
   */
  showBackButton(show) {
    this.ui.backButton.toggleClass('hidden', !show);
  }

  /**
   * Show the modal close button in the top right corner of the modal
   *
   * @param {boolean} show    When true, the button will be shown
   */
  showModalCloseButton(show) {
    this.ui.close.toggleClass('hidden', !show);
  }

  /**
   * Show the modal footer
   *
   * @param {boolean} show    When true, the footer region will be shown
   */
  showFooter(show) {
    this.ui.footer.toggleClass('hidden', !show);
  }

  /**
   * Sets the title displayed in the modal
   *
   * @param {string} title    The modal title
   */
  setTitle(title) {
    this.ui.title.html(title);
  }
}
